import React, { useContext, useState } from 'react';
import ReportForm from '../ReportForm/ReportForm';
import { ReportSkusModalContext } from './ReportSkusModal';
import { post } from '../../../../shared/components/ApiRequest';
import { updateReportItem, reportItemExists } from '../ReportForm/UpdateReportItem';

const Submit = (props) => {
  const { setStep, hideModal } = useContext(ReportSkusModalContext);
  const [formData, setFormData] = useState({});

  const handleSubmit = async (e) => {
    const currentWeek = $('#reportForm [name=weeks]').val();
    const data = await post('/my-account/report/report-titles', {...formData, titles: props.titles}, $(e.target));
    let reload = false;

    data.titles.map((titleData) => {
      updateReportItem(titleData.idRegistrationSong, titleData);

      if (!reload && currentWeek === titleData.week) {
        if (!reportItemExists(titleData.idRegistrationSong)) {
          reload = true;
        }
      }
    });

    hideModal();

    if (reload) {
      window.location.reload();
    }
  }

  return (
    <div>
      <ReportForm
        postedVideosChoices={props.postedVideosChoices}
        lyricUsesChoices={props.lyricUsesChoices}
        masterUsesChoices={props.masterUsesChoices}
        masterSourceChoices={props.masterSourceChoices}
        master={props.master}
        dataToFill={props.dataToFill}
        onChange={setFormData}
      ></ReportForm>

      <div className='row'>
        <div className='col-md-8 col-md-offset-2'>
          <div className='row'>
            <div className="col-sm-5 pr-0">
              <button onClick={() => setStep(2)} type="button" className="btn btn-block btn-purple">
                Back
              </button>
            </div>

            <div className="col-sm-7">
              <button onClick={handleSubmit} type="button" className="btn btn-block btn-purple">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Submit;